export default {"src":"/_next/static/media/mid-purple-left.aa8f7fea.svg","height":280,"width":1920,"blurWidth":0,"blurHeight":0};